import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f8d715c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { class: "app__page__title__container" }
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = { style: {"justify-content":"center","margin-left":"20px"} }
const _hoisted_6 = { style: {"display":"flex"} }
const _hoisted_7 = { class: "app__label--large" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_10 = {
  class: "app__title--small",
  style: {"margin":"auto"}
}
const _hoisted_11 = { class: "flex__column--center" }
const _hoisted_12 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_13 = { style: {"color":"black","font-weight":"900"} }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { class: "flex__column--center" }
const _hoisted_17 = { class: "row no-wrap items-center q-pa-sm q-gutter-xs" }
const _hoisted_18 = {
  key: 0,
  style: {"width":"100%","position":"relative"}
}
const _hoisted_19 = { class: "flex__column--center" }
const _hoisted_20 = { class: "row no-wrap items-center q-pa-sm q-gutter-xs" }
const _hoisted_21 = {
  key: 0,
  style: {"width":"100%","position":"relative"}
}
const _hoisted_22 = { class: "flex__column--center" }
const _hoisted_23 = { class: "row no-wrap items-center q-pa-sm q-gutter-xs" }
const _hoisted_24 = {
  key: 0,
  style: {"width":"100%","position":"relative"}
}
const _hoisted_25 = { style: {"display":"flex","justify-content":"flex-end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_tree = _resolveComponent("q-tree")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_uploader_add_trigger = _resolveComponent("q-uploader-add-trigger")!
  const _component_q_uploader = _resolveComponent("q-uploader")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_q_icon, {
            name: "category",
            style: {"font-size":"2rem","top":"-3px"},
            color: "primary"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.administration_types')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_q_btn, {
          "no-caps": "",
          dense: "",
          color: "blue",
          label: _ctx.$t('message.sync_types_categories'),
          onClick: _ctx.sincronizareTipuri
        }, null, 8, ["label", "onClick"])
      ])
    ]),
    _createVNode(_component_q_input, {
      outlined: "",
      modelValue: _ctx.filter,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter) = $event)),
      label: _ctx.$t('message.search_type'),
      dense: ""
    }, {
      append: _withCtx(() => [
        (_ctx.filter !== '')
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: "clear",
              class: "cursor-pointer",
              onClick: _ctx.resetFilter
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "label"]),
    _createVNode(_component_q_tree, {
      nodes: _ctx.treeDataCategories,
      "node-key": "appid",
      filter: _ctx.filter,
      "filter-method": _ctx.myFilterMethod,
      "default-expand-all": true,
      ref: "refTreeGrid"
    }, {
      "default-header": _withCtx((prop) => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(prop.node.is_tip == 'y' ? (_ctx.$i18n.locale === 'ro' ? prop.node.name_ro : _ctx.$i18n.locale === 'en' ? prop.node.name_en : prop.node.name_bg) : prop.node.name), 1),
          (prop.node.is_tip == 'y')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.appid))
              }, [
                _hoisted_9,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.edit_image')), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_8))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["nodes", "filter", "filter-method"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.isOpenDialogCategory,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isOpenDialogCategory) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, { style: {"display":"flex","align-items":"center"} }, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      color: "blue",
                      align: "center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "arrow_back_ios",
                          style: {"font-weight":"bold"}
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('message.edit_image')), 1),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      dense: "",
                      flat: "",
                      icon: "close",
                      color: "black"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512)), [
                      [_directive_close_popup]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { style: {"height":"85vh","max-width":"99vw"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_q_form, {
                        onSubmit: _ctx.onSubmitFormCategory,
                        onReset: _ctx.onResetFormCategory,
                        class: "q-gutter-md"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.editingCategory.size_type_ro), 1),
                            _hoisted_14,
                            _createVNode(_component_q_input, {
                              outlined: "",
                              modelValue: _ctx.editingCategory.size_type_en,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editingCategory.size_type_en) = $event)),
                              label: _ctx.label_editing_category + ' (EN)',
                              "input-style": "color:black;font-weight: 900;",
                              counter: "",
                              style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)"},
                              maxlength: "300"
                            }, null, 8, ["modelValue", "label"]),
                            _createVNode(_component_q_input, {
                              outlined: "",
                              modelValue: _ctx.editingCategory.size_type_bg,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editingCategory.size_type_bg) = $event)),
                              label: _ctx.label_editing_category + ' (BG)',
                              "input-style": "color:black;font-weight: 900;",
                              counter: "",
                              style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)"},
                              maxlength: "300"
                            }, null, 8, ["modelValue", "label"]),
                            _hoisted_15,
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_q_uploader, {
                                ref: "inputImgForCategory1",
                                label: _ctx.$t('message.upload_image_for_type'),
                                accept: ".jpg, .png, image/*",
                                "auto-upload": false,
                                color: "grey",
                                flat: "",
                                "hide-upload-button": true,
                                multiple: false,
                                style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)"},
                                onAdded: _ctx.imgForCategoryWasAdded1
                              }, {
                                header: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_17, [
                                    (scope.isUploading)
                                      ? (_openBlock(), _createBlock(_component_q_spinner, {
                                          key: 0,
                                          class: "q-uploader__spinner"
                                        }))
                                      : _createCommentVNode("", true),
                                    (scope.canAddFiles)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 1,
                                          type: "a",
                                          icon: "add_box",
                                          round: "",
                                          dense: "",
                                          flat: "",
                                          label: _ctx.$t('message.upload_image') + ' 1'
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_uploader_add_trigger),
                                            _createVNode(_component_q_tooltip, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.pick_files')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["label", "onAdded"]),
                              (_ctx.ImgCategoryString641.length>0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createVNode(_component_q_img, {
                                      src: _ctx.ImgCategoryString641,
                                      "spinner-color": "white",
                                      style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)","top":"-50px","margin":"auto"}
                                    }, {
                                      loading: _withCtx(() => [
                                        _createVNode(_component_q_spinner_gears, { color: "white" })
                                      ]),
                                      _: 1
                                    }, 8, ["src"]),
                                    _createVNode(_component_q_btn, {
                                      style: {"position":"absolute","top":"-45px","right":"5px"},
                                      dense: "",
                                      icon: "close",
                                      color: "primary",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteImage(1)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.delete_image')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_19, [
                              _createVNode(_component_q_uploader, {
                                ref: "inputImgForCategory2",
                                label: _ctx.$t('message.upload_image_for_type'),
                                accept: ".jpg, .png, image/*",
                                "auto-upload": false,
                                color: "grey",
                                flat: "",
                                "hide-upload-button": true,
                                multiple: false,
                                style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)"},
                                onAdded: _ctx.imgForCategoryWasAdded2
                              }, {
                                header: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_20, [
                                    (scope.isUploading)
                                      ? (_openBlock(), _createBlock(_component_q_spinner, {
                                          key: 0,
                                          class: "q-uploader__spinner"
                                        }))
                                      : _createCommentVNode("", true),
                                    (scope.canAddFiles)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 1,
                                          type: "a",
                                          icon: "add_box",
                                          round: "",
                                          dense: "",
                                          flat: "",
                                          label: _ctx.$t('message.upload_image') + ' 2'
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_uploader_add_trigger),
                                            _createVNode(_component_q_tooltip, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.pick_files')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["label", "onAdded"]),
                              (_ctx.ImgCategoryString642.length>0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_q_img, {
                                      src: _ctx.ImgCategoryString642,
                                      "spinner-color": "white",
                                      style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)","top":"-50px","margin":"auto"}
                                    }, {
                                      loading: _withCtx(() => [
                                        _createVNode(_component_q_spinner_gears, { color: "white" })
                                      ]),
                                      _: 1
                                    }, 8, ["src"]),
                                    _createVNode(_component_q_btn, {
                                      style: {"position":"absolute","top":"-45px","right":"5px"},
                                      dense: "",
                                      icon: "close",
                                      color: "primary",
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deleteImage(2)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.delete_image')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_q_uploader, {
                                ref: "inputImgForCategory3",
                                label: _ctx.$t('message.upload_image_for_type'),
                                accept: ".jpg, .png, image/*",
                                "auto-upload": false,
                                color: "grey",
                                flat: "",
                                "hide-upload-button": true,
                                multiple: false,
                                style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)"},
                                onAdded: _ctx.imgForCategoryWasAdded3
                              }, {
                                header: _withCtx((scope) => [
                                  _createElementVNode("div", _hoisted_23, [
                                    (scope.isUploading)
                                      ? (_openBlock(), _createBlock(_component_q_spinner, {
                                          key: 0,
                                          class: "q-uploader__spinner"
                                        }))
                                      : _createCommentVNode("", true),
                                    (scope.canAddFiles)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 1,
                                          type: "a",
                                          icon: "add_box",
                                          round: "",
                                          dense: "",
                                          flat: "",
                                          label: _ctx.$t('message.upload_image') + ' 3'
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_q_uploader_add_trigger),
                                            _createVNode(_component_q_tooltip, null, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('message.pick_files')), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }, 8, ["label"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["label", "onAdded"]),
                              (_ctx.ImgCategoryString643.length>0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createVNode(_component_q_img, {
                                      src: _ctx.ImgCategoryString643,
                                      "spinner-color": "white",
                                      style: {"min-width":"100px","max-width":"clamp(100px,90vw, 600px)","top":"-50px","margin":"auto"}
                                    }, {
                                      loading: _withCtx(() => [
                                        _createVNode(_component_q_spinner_gears, { color: "white" })
                                      ]),
                                      _: 1
                                    }, 8, ["src"]),
                                    _createVNode(_component_q_btn, {
                                      style: {"position":"absolute","top":"-45px","right":"5px"},
                                      dense: "",
                                      icon: "close",
                                      color: "primary",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteImage(3)))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_q_tooltip, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('message.delete_image')), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_q_btn, {
                              label: _ctx.$t('message.reset'),
                              type: "reset",
                              color: "primary",
                              flat: "",
                              class: "q-ml-sm"
                            }, null, 8, ["label"]),
                            _createVNode(_component_q_btn, {
                              label: _ctx.$t('message.submit'),
                              type: "submit",
                              color: "primary"
                            }, null, 8, ["label"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit", "onReset"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}